import { Document } from "@react-pdf/renderer";
type PDFDocumentProps = React.ComponentProps<typeof Document>;

const PDFDocument: React.FC<PDFDocumentProps> = (props) => (
    // @ts-ignore
    <Document {...props}>{props.children}</Document>
);

export default PDFDocument;
